const styles = {
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
};

export default styles;
